module.exports = __webpack_public_path__ + "static/0076-c5648133e1150be20c6e1768612e92dc.png";